module.exports = __webpack_public_path__ + "static/loopmobile-06dc31ae5946c31281950dbf890a2103.png";